;(function (angular, _, moment) {
  'use strict'

  const INVOICE_EXPORTED_PDF = 'Facture(s) exportée(s) en PDF !'
  const INVOICE_EXPORTED_FACTURX = 'Facture exportée en facture électronique !'
  // Fournisseur e-invoicing transmis à backend-kilo → service-factur-x : génère la
  // variante Factur-X Pennylane (SIRET vendeur, SIREN acheteur, mentions FR…) et
  // non plus la variante Chorus historique. Chorus garde son propre flux (backend-chorus).
  const FACTURX_PROVIDER = 'pennylane'
  const INVOICE_EXPORTED_CSV = 'Facture(s) exportée(s) en CSV !'
  const INVOICE_EXPORTED_SPREADSHEET = 'Facture(s) exportée(s) en feuille de calcul !'
  const QUOTE_EXPORTED_PDF = 'Devis exporté(s) en PDF !'
  const QUOTE_EXPORTED_CSV = 'Devis exporté(s) en CSV !'
  const QUOTE_EXPORTED_SPREADSHEET = 'Devis exporté(s) en feuille de calcul !'
  const CREDIT_NOTE_EXPORTED_PDF = 'Avoir(s) exporté(s) en PDF !'
  const CREDIT_NOTE_EXPORTED_CSV = 'Avoir(s) exporté(s) en CSV !'
  const CREDIT_NOTE_EXPORTED_SPREADSHEET = 'Avoir(s) exporté(s) en feuille de calcul !'
  const PAYMENTS_EXPORTED_SPREADSHEET = 'Paiement(s) exporté(s) en feuille de calcul !'
  const PAYMENTS_NOT_FOUND = 'Aucun paiement n\'est disponible sur ces dates'

  class ExportService {
    $http
    $uibModal
    snackService
    DatePickerService
    urls

    constructor (
      // Angular
      $http,
      // Libs
      $uibModal,
      // Managers
      // Services
      SnackService, DatePickerService, DisplayService,
      // Const
      urls, exportCols
      // Resolved
    ) {
      // DI
      this.$http = $http
      this.$uibModal = $uibModal
      this.snackService = SnackService
      this.datePickerService = DatePickerService
      this.displayService = DisplayService
      this.urls = urls
      this.exportCols = exportCols

      this.customRanges = [
        {
          label: 'Tous les paiements',
          range: moment().range(moment('2016-01-01'), moment().endOf('day'))
        },
        {
          label: '3 derniers mois',
          range: moment().range(moment().subtract(3, 'months').startOf('day'), moment().startOf('day'))
        },
        {
          label: 'Mois dernier',
          range: moment().range(moment().startOf('month').subtract(1, 'months').startOf('day'), moment().subtract(1, 'months').endOf('month').startOf('day'))
        },
        {
          label: '30 derniers jours',
          range: moment().range(moment().subtract(30, 'days').startOf('day'), moment().startOf('day'))
        },
        {
          label: 'Semaine dernière',
          range: moment().range(moment().startOf('week').subtract(1, 'weeks').startOf('day'), moment().subtract(1, 'weeks').endOf('week').startOf('day'))
        },
        {
          label: 'Cette semaine',
          range: moment().range(moment().startOf('isoweek').startOf('day'), moment().startOf('day'))
        },
        {
          label: '3 derniers jours',
          range: moment().range(moment().subtract(3, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day'))
        },
        {
          label: "Aujourd'hui",
          range: moment().range(moment().startOf('day'), moment().endOf('day'))
        }

      ]
    }

    /**
     * Prompt template selectionModal
     * @public
     * @param model {'invoice' | 'proforma' | 'creditNote' | 'quote'}
     * @return {Promise<Template>}
     */
    selectTemplateModal (model = 'invoice') {
      return this.$uibModal.open({
        controllerAs: 'select',
        bindToController: true,
        resolve: {
          type: function () { return model }
        },
        templateUrl: '/app/common/layouts/partials/modals/select-template.html',
        controller: 'SelectTemplateController'
      }).result
    }

    // PAYMENTS

    /**
     * Export payments as PDF
     * @public
     * @param clientId {string}
     * @return {Promise}
     */
    paymentAsSpreadsheet (clientId) {
      return this.datePickerService.getRange(moment.now(), {
        showRanged: true,
        customSelectOptions: this.customRanges
      }).then((period) => {
        period.start.utcOffset(0, true)
        period.end.utcOffset(0, true)
        let url = `${this.urls.backend}/services/spreadsheet/payments/`
        return this.$http.post(url, { period: period, clientId: clientId }, { 'ignoreErrors': [404] }).then(() => {
          this.snackService.snack({
            text: PAYMENTS_EXPORTED_SPREADSHEET,
            delay: 5000
          })
        })
      }).catch((error) => {
        if (error.status === 404) {
          this.snackService.snack({
            text: PAYMENTS_NOT_FOUND,
            color: '#d43f3a',
            delay: 5000
          })
        }
      })
    }

    // INVOICES

    /**
     * Export invoices as PDF
     * @public
     * @param invoiceID {string | string[]}
     * @param proforma {boolean}
     * @return {Promise}
     */
    invoiceAsPdf (invoiceID = [], proforma = false) {
      return this.selectTemplateModal(proforma ? 'proforma' : 'invoice')
        .then((template) => {
          let url = `${this.urls.backend}/services/pdf/invoice/`
          if (template?._id) {
            url += template._id
          }
          return this.$http.post(url, { invoices: this._arrayCoerce(invoiceID) }).then(() => {
            this.snackService.snack({
              text: INVOICE_EXPORTED_PDF,
              delay: 5000
            })
          })
        })
    }

    /**
     * Export invoices as FacturX
     * @public
     * @param invoiceID {string }
     * @param proforma {boolean}
     * @return {Promise}
     */
    invoiceAsFacturX (invoiceID = '') {
      let url = `${this.urls.backend}/services/pdf/facturx`
      return this.facturXValidation(invoiceID).then((data) => {
        if (data.isValid) {
          return this.$http.post(url, { invoice: invoiceID, provider: FACTURX_PROVIDER }).then(() => {
            this.snackService.snack({
              text: INVOICE_EXPORTED_FACTURX,
              delay: 5000
            })
          })
        } else {
          return this.displayService.missingFacturXData(data)
        }
      })
    }

    /**
     * Export creditNote as FacturX
     * @public
     * @param creditNoteID {string }
     * @param proforma {boolean}
     * @return {Promise}
     */
    creditNoteAsFacturX (creditNoteID = '') {
      let url = `${this.urls.backend}/services/pdf/facturx`
      return this.facturXValidation(creditNoteID, false, true).then((data) => {
        if (data.isValid) {
          return this.$http.post(url, { creditNote: creditNoteID, provider: FACTURX_PROVIDER }).then(() => {
            this.snackService.snack({
              text: INVOICE_EXPORTED_FACTURX,
              delay: 5000
            })
          })
        } else {
          return this.displayService.missingFacturXData(data)
        }
      })
    }

    /**
     * Export invoices as FacturX
     * @public
     * @param invoiceID {string }
     * @param proforma {boolean}
     * @return {Promise}
     */
    validateForFacturX (invoiceID = '') {
      let url = `${this.urls.backend}/services/pdf/facturx`
      return this.facturXValidation(invoiceID).then((data) => {
        if (data.isValid) {
          return this.$http.post(url, { invoice: invoiceID, provider: FACTURX_PROVIDER }).then(() => {
            this.snackService.snack({
              text: INVOICE_EXPORTED_FACTURX,
              delay: 5000
            })
          })
        } else {
          return this.displayService.missingFacturXData(data)
        }
      })
    }

    /**
     * Checks that invoice can be exported to facturX
     * @public
     * @param invoiceID {string }
     * @param proforma {boolean}
     * @return {Promise}
     */
    facturXValidation (invoiceID = '', displayError = false, isCreditNote = false, isBulk = false) {
      let url = `${this.urls.backend}/services/pdf/facturx${isCreditNote ? '/creditNote' : ''}/validation/${invoiceID}`
      return this.$http.post(url).then((response) => {
        if (displayError) {
          if (response.data.isValid) {
            return true
          } else {
            return this.displayService.missingFacturXData(response.data, isCreditNote)
          }
        } else {
          return response.data
        }
      })
    }
    /**
     * Checks that invoice can be exported to facturX
     * @public
     * @param invoiceID {string }
     * @param proforma {boolean}
     * @return {Promise}
     */
    facturXBulkValidation (invoices, creditNotes, displayError) {
      let url = `${this.urls.backend}/services/pdf/facturx/bulk/validation`
      return this.$http.post(url, { invoices, creditNotes }).then((response) => {
        if (displayError) {
          if (response.data.isValid) {
            return true
          } else {
            return this.displayService.missingFacturXData(response.data, true)
          }
        } else {
          return response.data
        }
      })
    }

    /**
     * Export given invoice with associated interventions
     * @param invoiceID {string}
     * @return {Promise}
     */
    invoiceAsPdfWithInterventions (invoiceID) {
      return this.selectTemplateModal('invoice').then((template) => {
        let url = `${this.urls.backend}/services/pdf/invoice-with-interventions/`
        if (template !== false) {
          url += template._id
        }
        return this.$http.post(url, { invoice: invoiceID }).then(() => {
          this.snackService.snack({
            text: INVOICE_EXPORTED_PDF,
            delay: 5000
          })
        })
      })
    }

    quoteAsPdfWithInterventions (quoteID) {
      return this.selectTemplateModal('quote').then((template) => {
        let url = `${this.urls.backend}/services/pdf/quote-with-interventions/`
        if (template !== false) {
          url += template._id
        }
        return this.$http.post(url, { quote: quoteID }).then(() => {
          this.snackService.snack({
            text: QUOTE_EXPORTED_PDF,
            delay: 5000
          })
        })
      })
    }

    /**
     * Export invoices as CSV
     * @param invoiceID {string|string[]}
     * @return {Promise}
     */
    invoiceAsCsv (invoiceID) {
      const url = `${this.urls.backend}/services/csv/invoices/`
      return this.$http.post(url, { invoices: this._arrayCoerce(invoiceID) }).then(() => {
        this.snackService.snack({
          text: INVOICE_EXPORTED_CSV,
          delay: 5000
        })
      })
    }

    /**
     *
     * @param invoiceID {string | string[]}
     * @return {Promise}
     */
    invoiceAsSpreadsheet (invoiceID) {
      const url = `${this.urls.backend}/services/spreadsheet/invoices/`
      return this.$http.post(url, { invoices: this._arrayCoerce(invoiceID) }).then(() => {
        this.snackService.snack({
          text: INVOICE_EXPORTED_SPREADSHEET,
          delay: 5000
        })
      })
    }

    // QUOTES

    /**
     * Export quotes as PDF
     * @public
     * @param quoteID {string | string[]}
     * @param options {object}
     * @return {Promise}
     */
    quoteAsPdf (quoteID = [], options = {}) {
      let promise
      if (options.templateId) {
        promise = Promise.resolve({ _id: options.templateId })
      } else {
        promise = this.selectTemplateModal('quote')
      }
      return promise
        .then((template) => {
          let url = `${this.urls.backend}/services/pdf/quote/`
          if (template?._id) {
            url += template._id
          }
          return this.$http.post(url, { quotes: this._arrayCoerce(quoteID), sync: options.sync }).then((data) => {
            this.snackService.snack({
              text: QUOTE_EXPORTED_PDF,
              delay: 5000
            })
            if (options.sync) {
              return data
            }
          })
        })
    }

    /**
     * Export quotes as CSV
     * @param quoteID {string|string[]}
     * @return {Promise}
     */
    quoteAsCsv (quoteID) {
      const url = `${this.urls.backend}/services/csv/quotes/`
      return this.$http.post(url, { quotes: this._arrayCoerce(quoteID) }).then(() => {
        this.snackService.snack({
          text: QUOTE_EXPORTED_CSV,
          delay: 5000
        })
      })
    }

    /**
     *
     * @param quoteID {string | string[]}
     * @return {Promise}
     */
    quoteAsSpreadsheet (quoteID) {
      const url = `${this.urls.backend}/services/spreadsheet/quotes/`
      return this.$http.post(url, { quotes: this._arrayCoerce(quoteID) }).then(() => {
        this.snackService.snack({
          text: QUOTE_EXPORTED_SPREADSHEET,
          delay: 5000
        })
      })
    }

    // CREDIT NOTES

    /**
     * Export credit notes as PDF
     * @public
     * @param creditNoteID {string | string[]}
     * @return {Promise}
     */
    creditNoteAsPdf (creditNoteID = []) {
      return this.selectTemplateModal('creditnote')
        .then((template) => {
          let url = `${this.urls.backend}/services/pdf/creditnote/`
          if (template?._id) {
            url += template._id
          }
          return this.$http.post(url, { creditNotes: this._arrayCoerce(creditNoteID) }).then(() => {
            this.snackService.snack({
              text: CREDIT_NOTE_EXPORTED_PDF,
              delay: 5000
            })
          })
        })
    }

    /**
     * Export credit notes as CSV
     * @param creditNoteID {string|string[]}
     * @return {Promise}
     */
    creditNoteAsCsv (creditNoteID) {
      const url = `${this.urls.backend}/services/csv/creditnotes/`
      return this.$http.post(url, { creditNotes: this._arrayCoerce(creditNoteID) }).then(() => {
        this.snackService.snack({
          text: CREDIT_NOTE_EXPORTED_CSV,
          delay: 5000
        })
      })
    }

    /**
     * Export credit notes as spreadsheet
     * @param creditNoteID {string | string[]}
     * @return {Promise}
     */
    creditNoteAsSpreadsheet (creditNoteID) {
      const url = `${this.urls.backend}/services/spreadsheet/creditnotes/`
      return this.$http.post(url, { creditNotes: this._arrayCoerce(creditNoteID) }).then(() => {
        this.snackService.snack({
          text: CREDIT_NOTE_EXPORTED_SPREADSHEET,
          delay: 5000
        })
      })
    }

    // PRIVATES

    /**
     * Ensure the element is an array
     * @param input {string|object|array}
     * @return (string|Object|Array)[]
     * @private
     */
    _arrayCoerce (input) {
      if (Array.isArray(input)) {
        return input
      }
      return [input]
    }

    searchToSpreadsheet (conditions, total, mode) {
      const payload = {
        conditions,
        cols: this.exportCols,
        objectType: mode
      }
      if (!payload.conditions) {
        payload.conditions = {}
      }
      if (!this.checkIsArchivedPresent(payload.conditions)) {
        payload.conditions.isArchived = { $in: [ true, false ] }
        payload.conditions.isDeleted = false
      } else if (this.normalizeIsArchived(payload.conditions)) {
        payload.conditions.isArchived = { $in: [true] }
        payload.conditions.isDeleted = false
      }
      payload.conditions.isModel = { $exists: false }
      return this.displayService.displayConfirm(
        `Export Excel`,
        `Vous allez exporter ${total} élèments.
        Veuillez confirmer l'action.`
      ).then(() => {
        return this.$http({
          url: `${this.urls.backend}/services/spreadsheet/bulk`,
          method: 'post',
          data: payload
        }).then(() => {
          this.displayService.displayReportPending('xlsx')
        })
      })
    }
    checkIsArchivedPresent (queryObject) {
      // Si l'objet contient directement isArchived
      if ('isArchived' in queryObject) {
        return true
      }

      // Vérifier dans $and
      if (queryObject.$and) {
        for (const condition of queryObject.$and) {
          if ('isArchived' in condition) {
            return true
          }
        }
      }

      // Vérifier dans $or
      if (queryObject.$or) {
        for (const condition of queryObject.$or) {
          if ('isArchived' in condition) {
            return true
          }
        }
      }

      return false
    }

    normalizeIsArchived (queryObject) {
      if ('isArchived' in queryObject && queryObject.isArchived === true) {
        return true
      }

      // Normaliser dans $and
      if (queryObject.$and) {
        for (let i = 0; i < queryObject.$and.length; i++) {
          const condition = queryObject.$and[i]
          if ('isArchived' in condition && condition.isArchived === true) {
            delete queryObject.$and[i].isArchived
            if (Object.keys(queryObject.$and[i]).length === 0) {
              queryObject.$and.splice(i, 1)
              i--
            }
            return true
          }
        }
      }
      if (queryObject.$or) {
        for (let i = 0; i < queryObject.$or.length; i++) {
          const condition = queryObject.$or[i]
          if ('isArchived' in condition && condition.isArchived === true) {
            delete queryObject.$or[i].isArchived
            if (Object.keys(queryObject.$or[i]).length === 0) {
              queryObject.$or.splice(i, 1)
              i--
            }
            return true
          }
        }
      }

      return false
    }
  }

  ExportService.$inject = [
    // Angular
    '$http',
    // Libs
    '$uibModal',
    // Managers
    // Services
    'SnackService', 'DatePickerService', 'DisplayService',
    // Const
    'urls', 'exportCols'
    // Resolved
  ]

  angular.module('kilo.common.services')
    .service('ExportService', ExportService)
})(window.angular, window._, window.moment)
